import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 身分證件上傳
 */
const ProofDocUploadPostBack = [
    'POST',
    RouteUrlList.API_ProofDocUploadPostBack.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: ''
    }
];
export default ProofDocUploadPostBack;
